import { CSSProperties } from 'react';
import {
  ACCENT_BUTTON,
  COLORS,
  FONTS,
  GLASS,
  META,
} from '../../globalStyles';

const glassField: CSSProperties = {
  ...GLASS,
  border: `1px solid ${COLORS.border}`,
  borderRadius: 0,
  color: COLORS.text,
  fontFamily: FONTS.body,
  fontSize: '1rem',
  padding: '0.7rem 0.9rem',
  transition: 'border-color 0.15s',
  width: '100%',
  minWidth: 0,
};

const topic: CSSProperties = {
  fontFamily: FONTS.body,
  fontSize: '1rem',
  padding: '0.6rem 1rem',
  borderRadius: 0,
  cursor: 'pointer',
};

export const styles: Record<string, CSSProperties> = {
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.1rem',
  },
  formRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '1.1rem',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    minWidth: 0,
  },
  label: {
    ...META,
    fontSize: '0.66rem',
    color: COLORS.label,
  },
  input: glassField,
  textarea: { ...glassField, resize: 'none' as const },
  fieldInvalid: { borderColor: COLORS.error },
  fieldErrorText: {
    ...META,
    fontSize: '0.6rem',
    color: COLORS.error,
    marginTop: '0.15rem',
  },
  topics: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem',
  },
  topic: {
    ...topic,
    ...GLASS,
    border: `1px solid ${COLORS.borderStrong}`,
    color: COLORS.muted,
  },
  topicSelected: {
    ...topic,
    background: COLORS.accent,
    border: `1px solid ${COLORS.accent}`,
    color: COLORS.onAccent,
  },
  topicsInvalid: {
    outline: `1px solid ${COLORS.error}`,
    outlineOffset: '4px',
  },
  submitNovaeon: {
    ...META,
    ...ACCENT_BUTTON,
    padding: '0.85rem 1.9rem',
    fontSize: '0.72rem',
    alignSelf: 'flex-start',
    marginTop: '0.5rem',
  },
  submitPlayerCafe: {
    ...ACCENT_BUTTON,
    fontFamily: FONTS.body,
    fontWeight: 600,
    fontSize: '1rem',
    padding: '0.95rem 1.75rem',
    alignSelf: 'flex-start',
    marginTop: '0.5rem',
  },
  honeypot: {
    position: 'absolute',
    left: '-9999px',
    width: '1px',
    height: '1px',
    opacity: 0,
    overflow: 'hidden',
  },
  feedback: {
    ...META,
    fontSize: '0.66rem',
    lineHeight: 1.6,
    marginTop: '0.9rem',
    alignSelf: 'flex-start',
  },
  feedbackError: { color: COLORS.error },
  feedbackSuccess: { color: COLORS.accent },
};
